import { useEffect, useState } from 'react';
import Metrics from '/@/components/metrics';
import Notes from '/@/components/notes';
import { DensityModule, Refuge } from '/@/components/product-datasheet';
import Title from '/@/components/title';
import { _ } from '/@/locale';
import TechnologyList from '/@/views/catalog/technology-list';
import styles from '../../../views/product-datasheet/preview/styles.module.css';

const ProductPreview = ({ productDatasheet, profile, brand, country }) => {
    const [userDensity, setUserDensity] = useState(null);
    const [userEstimatedYield, setUserEstimatedYield] = useState(null);
    const [showLineOnChart, setShowLineOnChart] = useState(null);

    const handleDensityInput = (value) => {
        setUserEstimatedYield(value);
    };

    const hasMetrics = (profile) => {
        return (
            productDatasheet.modulesIds.includes('metrics') &&
            !!(profile.metrics || []).length &&
            productDatasheet.metricsIds.length
        );
    };

    const hasFeatures = (profile) => {
        return (
            productDatasheet.modulesIds.includes('features') &&
            !!(profile.features || []).length &&
            productDatasheet.featuresIds.length
        );
    };

    const hasRefuge = (profile) => {
        return productDatasheet.modulesIds.includes('refugeOptions') && !!(profile.refugeOptions || []).length;
    };

    useEffect(() => {
        document.getElementById('app-content')?.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.container}>
            <div className={styles.headline}>
                <div className={styles.title}>{_(profile.catalogName)}</div>
                <div className={styles.subtitle}>{_(profile.shortDescription)}</div>
            </div>
            {!!profile.notes.length && (
                <div className={styles.description}>
                    {!!profile.notes.length && (
                        <div className={styles.information}>
                            <Title size='xl' underline>
                                {_('Descripción general')}
                            </Title>
                            <Notes notes={profile.notes} columns={2} />
                        </div>
                    )}
                    {!!profile.technologies.length && (
                        <div className={styles.technologies}>
                            <TechnologyList
                                type={productDatasheet.type}
                                brand={brand}
                                technologies={profile.technologies}
                                title='Tecnologías'
                            />
                        </div>
                    )}
                </div>
            )}
            <DensityModule
                profile={profile}
                productDatasheet={productDatasheet}
                userEstimatedYield={userEstimatedYield}
                changeUserDensity={(val) => setUserDensity(val)}
                brand={brand}
                handleDensityInput={handleDensityInput}
                userDensity={userDensity}
                showLineOnChart={showLineOnChart}
            />
            {hasMetrics(profile) && (
                <div className={styles.section}>
                    <Title size='xl' underline>
                        {_('Perfil defensivo')}
                    </Title>
                    <Metrics
                        highlight
                        dots
                        title={_('Perfil defensivo')}
                        dataKey='metrics'
                        brand={brand}
                        products={[profile]}
                        country={country}
                        filterMetrics={productDatasheet.metricsIds}
                    />
                </div>
            )}
            {hasFeatures(profile) && (
                <div className={styles.section}>
                    <Title size='xl' underline>
                        {_('Características')}
                    </Title>
                    <Metrics
                        highlight
                        title={_('Características')}
                        dataKey='features'
                        products={[profile]}
                        brand={brand}
                        country={country}
                        filterMetrics={productDatasheet.featuresIds}
                    />
                </div>
            )}
            {hasRefuge(profile) && (
                <div className={styles.section}>
                    <Refuge country={country} type={productDatasheet.type} />
                </div>
            )}
        </div>
    );
};

export default ProductPreview;
